export default __webpack_public_path__ + "static/media/s1-project@2x.08ae57bc.jpg";